<template>
  <div class="nav-wrapper">
    <div class="nav-title">树洞狸管理后台</div>
    <el-menu
      :default-active="munuIndex"
      class="el-menu-vertical-demo"
      active-text-color="#dc143c"
      :router="true"
      @select="selectMenu"
    >
    <el-menu-item v-for="(item, i) in munuList" :key="i + 'munuList'" :index="item.key" :route="item.route">
      <i :class="item.icon"></i>
      <span slot="title">{{item.title}}</span>
    </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
export default {
  name: "Nav",
  computed: {
    ...mapState({
      munuList: state => state.nav.munuList,
      munuIndex: state => state.nav.munuIndex,
    }),
  },
  methods: {
    selectMenu(index) {
      this.$store.commit('setMunuIndex', index)
    }
  },
};
</script>

<style scoped>
.nav-wrapper {
  border-right: 1px solid #e6e6e6;
  height: 100%;
}
.nav-title {
  color: #303133;
  font-weight: bold;
  font-size: 18px;
  padding-left: 20px;
  width: 100%;
  height: 50px;
  line-height: 50px;
  box-sizing: border-box;
}
</style>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.el-menu-vertical-demo.el-menu {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Nav.vue